export const BENEFIT_CREATE = "benefitCreate";
export const BENEFIT_EDIT = "benefitEdit";
export const BENEFIT_EDIT_USERS = "benefitEditUsers";
export const BENEFIT_GET = "benefitGet";
export const BENEFITS_GET = "benefitsGet";
export const BENEFIT_SEARCH = "benefitSearch";
export const BENEFIT_ACTIVE = "benefitActive"
export const BENEFIT_INACTIVE = "benefitInactive"